export const ANALYTICS_HERO_TRACK_SUCCESS = '[analytics] hero track success';
export type TrackHeroTrackSuccess = {
  type: typeof ANALYTICS_HERO_TRACK_SUCCESS;
};
export const trackHeroTrackSuccess:TrackHeroTrackSuccess = {
  type: ANALYTICS_HERO_TRACK_SUCCESS,
};

export type AnalyticsAction = TrackHeroTrackSuccess;
